// src/api.js

let API_URL;

if (process.env.NODE_ENV === "production") {
  // On Vercel (live site), use the Render backend
  API_URL = process.env.REACT_APP_API_URL;
} else {
  // On localhost, fallback to your local backend
  API_URL = "http://localhost:5000";
}

export default API_URL;